import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	createLabel: {
		id: 'issue-table-inline-issue-create.inline-create-trigger.create-label',
		defaultMessage: 'Create',
		description: 'Label of the button to create an issue.',
	},
});
